import Form, { ButtonItem, ButtonOptions, CustomRule, Item, Label, RequiredRule } from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import React, { useCallback, useEffect, useRef } from "react";
import { ValidationSummary } from "devextreme-react/validation-summary";
import notify from "devextreme/ui/notify";
import { useNavigate } from "react-router";
import { useChangePasswordMutation } from "../api/change-password";

const oldPasswordEditorOptions = {
    placeholder: 'Old Password',
    mode: 'password',
    validationMessagePosition: 'down'
};
const newPasswordEditorOptions = {
    placeholder: 'New Password',
    mode: 'password',
    validationMessagePosition: 'down'
};
const confirmNewPasswordEditorOptions = {
    placeholder: 'Confirm New Password',
    mode: 'password',
    validationMessagePosition: 'down'
};

const submitButtonAttributes = { class: 'submit-button' };

export default function ChangePasswordControl() {

    const mutation = useChangePasswordMutation();
    const formData = useRef({ oldPassword: '', newPassword: '', confirmNewPassword: '' });
    const navigate = useNavigate();

    useEffect(() => {
        if (mutation.isLoading)
            return;
        if (mutation.data === undefined)
            return;

        if (mutation.data?.isOk) {
            notify('Password has been updated', 'success', 2500);
        } else {
            notify(mutation.data?.message, 'error', 2000);
        }
    }, [mutation.isLoading, mutation.data]);

    const onSubmit = useCallback(async (e: any) => {
        e.preventDefault();
        const { newPassword, oldPassword } = formData.current;
        await mutation.mutate({ oldPassword: oldPassword, newPassword: newPassword });
    }, [mutation]);

    const confirmPassword = useCallback(
        ({ value }: any) => value === formData.current.newPassword,
        []
    );

    return <>
        <form onSubmit={onSubmit}>
            <Form formData={formData.current} disabled={mutation.isLoading} requiredMark={""}
                showValidationSummary={true}
                colCount={2} width={470} style={{ margin: "0px auto" }}>

                <Item
                    dataField={'oldPassword'}
                    editorType={'dxTextBox'}
                    colSpan={2}
                    editorOptions={oldPasswordEditorOptions}>
                    <Label text={'Old Password'} />
                    <RequiredRule message="Old Password is required" />
                </Item>
                <Item
                    dataField={'newPassword'}
                    editorType={'dxTextBox'}
                    colSpan={2}
                    editorOptions={newPasswordEditorOptions}>
                    <Label text={'New Password'} />
                    <RequiredRule message="New Password is required" />
                </Item>
                <Item
                    dataField={'confirmNewPassword'}
                    editorType={'dxTextBox'}
                    colSpan={2}
                    editorOptions={confirmNewPasswordEditorOptions}
                >
                    <RequiredRule message="Confirm New Password is required" />
                    <CustomRule
                        message={'Passwords do not match'}
                        validationCallback={confirmPassword}
                    />
                    <Label text={'Confirm New Password'} />
                </Item>
                <ButtonItem horizontalAlignment="center">
                    <ButtonOptions
                        elementAttr={submitButtonAttributes}
                        useSubmitBehavior={true}
                        width={'100%'}
                    >
                        <span className="dx-button-text">
                            {
                                mutation.isLoading
                                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                                    : 'Save'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>
                <ButtonItem horizontalAlignment="center">
                    <ButtonOptions
                        useSubmitBehavior={false}
                        width={'100%'}
                        disabled={mutation.isLoading}
                        onClick={() => {
                            navigate('/home');
                        }}
                    >
                        <span className="dx-button-text">Cancel</span>
                    </ButtonOptions>
                </ButtonItem>
                <ValidationSummary id="summary"></ValidationSummary>
            </Form>
        </form>
    </>
}

